import { render, staticRenderFns } from "./wtDuration.component.vue?vue&type=template&id=39d4c94f&"
import script from "./wtDuration.component.vue?vue&type=script&lang=js&"
export * from "./wtDuration.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports